import Box from '@mui/material/Box';
import { SxProps, Theme } from '@mui/material/styles';

import { Breadcrumbs } from 'common/components/Breadcrumbs';
import { Button } from 'common/components/Button';
import { ContextActionBar } from 'common/components/ContextActionBar';
import { Link } from 'common/components/Link';
import { ICollectionFragment } from 'graphql/types';

const rowStyle: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
    width: '100%',
};

interface IProps {
    actions?: React.ReactNode;
    /** Omit to hide the trail, e.g. on the library root itself. */
    libraryTitle?: string;
    parent?: ICollectionFragment['parent'];
}

export const LibraryContextActionBar = ({
    actions,
    libraryTitle,
    parent,
}: IProps) => {
    if (!libraryTitle && !actions) return null;

    return (
        <ContextActionBar>
            <Box sx={rowStyle}>
                {!!libraryTitle && (
                    <Breadcrumbs>
                        <Button
                            component={Link}
                            size="small"
                            to="LIBRARY"
                            variant="text"
                        >
                            {libraryTitle}
                        </Button>
                        {parent && !parent.root && (
                            <Button
                                component={Link}
                                params={{ id: parent.id }}
                                size="small"
                                to="LIBRARY_COLLECTION"
                                variant="text"
                            >
                                {parent.title}
                            </Button>
                        )}
                    </Breadcrumbs>
                )}
                {actions && (
                    <Box sx={{ display: 'flex', ml: 'auto', flexShrink: 0 }}>
                        {actions}
                    </Box>
                )}
            </Box>
        </ContextActionBar>
    );
};
